<template>
	<div class="col-12 text-center">
		<div class="row justify-content-center">
			<div class="row col-12 col-xl-4 bg-white justify-content-center">
				
				<!-- <img v-if="producto.nuevo" class="d-lg-none img-fluid tamano-liston" src="@/assets/img-priv/Liston nuevo.png"/>
				<img v-if="producto.ofertado" class="d-lg-none img-fluid tamano-liston" src="@/assets/img-priv/Liston oferta.png"/>-->
				<div class="p-0 mt-0">
					<div class="tag-nuevo d-xl-none" v-if="producto.nuevo && !producto.buenFin">NUEVO</div>
					<div class="tag-oferta d-xl-none" v-else-if="producto.ofertado && !producto.buenFin">OFERTA</div>
					<div class="tag-remate d-xl-none" v-else-if="producto.remate && !producto.buenFin">REMATE</div>
					<div class="tag-remate d-xl-none" v-else-if="producto.buenFin">BUEN FIN</div>
					<!-- <img class="tamano-imagen" :src="urlImagen"> -->
					<img v-if="producto.buenFin" class="logo-buenfin" src="@/assets/img-priv/bfxs.png"/>
					<img :src="imagenOptima(producto)" @error="imagenDefault(producto)" class="tamano-imagen" />
				</div>
				<div class="col-12 alineat-abajo">
					<!--Bandera e iconos-->
					<div class="row justify-content-center">
						<div class="col-4 form-group text-center" v-if="paisOrigen.codPaisOrigen">
							<label class="fuente-pais pl-3">Hecho en</label>
							<br />
							<img :src="paisOrigen.imagen" class="img-bandera pl-3" />
							<br />
							<label class="fuente-pais pl-3">{{paisOrigen.descripcion}}</label>
						</div>
						<div class="col-8 text-right d-inline-block mt-4 mt-xl-4">
							<img
								class="tamano-icono"
								src="@/assets/img-priv/icon_pp.png"
								title="Producto publicitado"
								v-b-tooltip.hover
								v-if="producto.pp"
							/>
							<img
								class="tamano-icono"
								src="@/assets/img-priv/icon_ftp.png"
								title="Fármaco de tratamiento prolongado"
								v-b-tooltip.hover
								v-if="producto.ftp"
							/>
							<img
								class="tamano-icono"
								src="@/assets/img-priv/icon_mdp.png"
								title="Medicamento de prescripción"
								v-b-tooltip.hover
								v-if="producto.mdp"
							/>
							<img
								class="tamano-icono"
								src="@/assets/img-priv/icon_otc.png"
								title="Producto de libre venta"
								v-b-tooltip.hover
								v-if="producto.otc"
							/>
							<img
								class="tamano-icono"
								src="@/assets/img-priv/icon_psp.png"
								title="Producto sobre pedido"
								v-b-tooltip.hover
								v-if="producto.psp"
							/>
							<img
								class="tamano-icono"
								src="@/assets/img-priv/icon_generico.png"
								title="Producto de generico"
								v-b-tooltip.hover
								v-if="producto.gi"
							/>
						</div>
					</div>
				</div>
			</div>

			<div class="col-12 col-xl-8 bg-white">
				<div class="row col-12">
					<!--Liston-->
					<div class="col-12 text-left d-none d-xl-block">
						<!-- <img v-if="producto.nuevo"  src="@/assets/img-priv/Liston nuevo.png"/>
						<img v-if="producto.ofertado" src="@/assets/img-priv/Liston oferta.png"/>-->
						<div class="tag-nuevo plxl" v-if="producto.nuevo && !producto.buenFin">NUEVO</div>
						<div class="tag-oferta plxl" v-else-if="producto.ofertado && !producto.buenFin">OFERTA</div>
						<div class="tag-remate plxl" v-else-if="producto.remate && !producto.buenFin">REMATE</div>
						<div class="tag-remate plxl" v-else-if="producto.buenFin">BUEN FIN</div>
					</div>
					<!--Titulo, generico y formula-->

					<div class="col-11 fuenteTitulo mt-xl-4 pt-xl-2 d-inline-block">
						<img class="estrella" src="@/assets/img-priv/Estrella.png" v-if="producto.pertenecePedido" />
						{{producto.descripcion}}
					</div>
					<div class="col-11 pl-4 fuenteGenerico">Gen&eacute;rico: {{producto.generico}}</div>
					<div class="col-md-10 fuenteFormula d-none d-md-block pl-4" v-if="!visibleFormula">
						<p>
							F&oacute;mula:
							<!-- {{ producto.formula }} -->
							<!-- <span v-text="cortarTexto(producto.formula, 120)"></span> -->
							<span>{{producto.formula}}</span>
						</p>
					</div>
					<div class="col-8 fuenteFormula d-block d-md-none pl-4" v-if="!visibleFormula">
						F&oacute;mula:
						<span v-text="cortarTexto(producto.formula, 20)"></span>
					</div>
					<!-- <div
						@click="cambiarVistaFormula"
						class="col-2 col-md-1 color-azul justify-content-end"
						v-if="!visibleFormula"
					>
						<i class="fas fa-plus-circle fa-1x"></i>
					</div> -->
					<div
						class="col-8 col-md-10 fuenteFormula pl-4"
						v-if="visibleFormula"
					>F&oacute;mula: {{producto.formula}}</div>
					<div
						@click="cambiarVistaFormula"
						class="col-2 col-md-1 color-azul justify-content-end"
						v-if="visibleFormula"
					>
						<i class="fas fa-minus-circle fa-1x"></i>
					</div>
				</div>
				<div class="linea"></div>
				<div class="row col-12">
					<div class="col-6 col-md-4 text-left">
						<span class="cuadriculaTitulo">Laboratorio:</span>
						<br />
						<span class="cuadriculaDetalle">{{producto.marca}}</span>
					</div>
					<div class="col-6 col-md-4 text-left">
						<span class="cuadriculaTitulo">Clasificaci&oacute;n:</span>
						<br />
						<span class="cuadriculaDetalle">{{producto.clasificacion}}</span>
					</div>
					<div class="col-md-4 d-none d-md-block text-left">
						<span class="cuadriculaTitulo">Registro S.S.A.:</span>
						<br />
						<span class="cuadriculaDetalle">{{producto.registroSSA}}</span>
					</div>

					<div class="col-6 col-md-4 text-left">
						<span class="cuadriculaTitulo">C&oacute;digo de barras:</span>
						<br />
						<span class="cuadriculaDetalle">{{producto.codBarras}}</span>
					</div>
					<div class="col-6 col-md-4 text-left">
						<span class="cuadriculaTitulo">C&oacute;digo SAT:</span>
						<br />
						<span class="cuadriculaDetalle">{{producto.codigoSat}}</span>
					</div>
					<div class="col-md-4 d-none d-md-block text-left">
						<span class="cuadriculaTitulo">C&oacute;digo Difarmer:</span>
						<br />
						<span class="cuadriculaDetalle">{{producto.codArticulo}}</span>
					</div>

					<div class="col-6 col-md-4 text-left">
						<span class="cuadriculaTitulo">Precio P&uacute;blico:</span>
						<br />
						<span class="cuadriculaDetalle">
							<span v-if="producto.precioPublico > 0">
								{{producto.precioPublico | format-number('$0,0.00')}}
							</span>
						</span>
					</div>
					<div class="col-6 col-md-4 text-left">
						<span class="cuadriculaTitulo">Colectivo:</span>
						<br />
						<span class="cantidad-colectivo">{{producto.empColectivo}}</span>
					</div>
					<div class="col-md-4 d-none d-md-block text-left">
						<span class="cuadriculaTitulo">C&oacute;digo CCBSS:</span>
						<br />
						<span class="cuadriculaDetalle">{{producto.ccb}}</span>
					</div>
					<div class="col-md-4 d-none d-md-block text-left" v-if="producto.tipoControl == 1">
						<span class="cuadriculaTitulo">Temperatura:</span>
						<br />
						<i class="icon-trazado-1109 cuadriculaDetalle"></i>
						<span class="cuadriculaDetalle">{{producto.temperatura}}</span>
					</div>
					<div class="col-6 col-md-4 text-left">
						<span class="cuadriculaTitulo">Existencia:</span>
						<br />
						<span class="cuadriculaDetalle mt-2">{{usuarioGlobal().sucursal}}:</span>
						<span class="cantidad-existencia pl-1">{{producto.existenciaMiCedis | format-number('0,0')}}</span>
					</div>
					<div class="col-6 col-md-4 text-left">
						<br />
						<span class="cuadriculaDetalle">Otros CEDIS:</span>
						<span class="cantidad-existencia pl-1">{{producto.existenciaOtrosCedis | format-number('0,0')}}</span>
					</div>
					<div class="col-6 d-block d-md-none text-left">
						<span class="cuadriculaTitulo">Registro S.S.A.:</span>
						<br />
						<span class="cuadriculaDetalle">{{producto.registroSSA}}</span>
					</div>
					<div class="col-6 d-block d-md-none text-left">
						<span class="cuadriculaTitulo">C&oacute;digo CCBSS:</span>
						<br />
						<span class="cuadriculaDetalle">{{producto.ccb}}</span>
					</div>
					<div class="col-6 d-block d-md-none text-left" v-if="producto.tipoControl == 1">
						<span class="cuadriculaTitulo">Temperatura:</span>
						<br />
						<i class="icon-trazado-1109 cuadriculaTitulo"></i>
						<span class="cuadriculaDetalle">{{producto.temperatura}}</span>
						
					</div>
					<div class="col-6 d-block d-md-none text-left">
						<span class="cuadriculaTitulo">C&oacute;digo Difarmer:</span>
						<br />
						<span class="cuadriculaDetalle">{{producto.codArticulo}}</span>
					</div>
				</div>
				<div style="text-align: left;" class="texto-producto-sin-devolucion" v-if="producto.sinDerechoDevolucion">* Producto sin derecho a devolución</div>
				<div v-if="(producto.existenciaMiCedis > 0 && (producto.ofertado || producto.remate)) || !producto.sinDerechoDevolucion" class="row col-12">
					<div class="col-lg-5 col-md-7 mt-2 ml-2 div-fechacaducidad">
						<div v-if="producto.existenciaMiCedis > 0 && (producto.ofertado || producto.remate)" class="col-12">
							<span class="mr-1 font-14">Fecha de caducidad: {{producto.fechaCaducidad | format-date('DD/MMM/YYYY') }}</span>
						</div>
						<div class="col-12">
							<span v-if="!producto.sinDerechoDevolucion" class="mr-1 font-14">Producto con derecho a devolución</span>
						</div>
					</div>
				</div>
				<div class="linea"></div>
				<!--Indicacion Terapeutica-->
				<div class="row col-12">
					<div class="text-left col-12">
						<span class="cuadriculaTitulo">Indicaci&oacute;n terap&eacute;utica:</span>
						<br />
					</div>
					<div
						class="col-md-10 d-md-block cuadriculaDetalle pl-4 pb-2"
						v-if="!visibleIndicacionTerapeutica"
					>
					<span>{{producto.accionTerapeutica}}</span>
					</div>
					<!-- <div
						class="col-md-10 d-none d-md-block cuadriculaDetalle pl-4"
						v-if="!visibleIndicacionTerapeutica"
					>
						<span v-text="cortarTexto(producto.accionTerapeutica, 140)"></span>
					</div>
					<div
						class="col-8 d-block d-md-none cuadriculaDetalle pl-4"
						v-if="!visibleIndicacionTerapeutica"
					>
						<span v-text="cortarTexto(producto.accionTerapeutica, 40)"></span>
					</div>
					<div
						@click="cambiarVistaIndicacionTerapeutica"
						class="col-2 col-md-1 color-azul justify-content-end"
						v-if="!visibleIndicacionTerapeutica"
					>
						<div class="d-none d-md-block">
							<i
								class="fas fa-plus-circle fa-1x"
								v-if="producto.accionTerapeutica != null && producto.accionTerapeutica.length > 140"
							></i>
						</div>
						<div class="d-block d-md-none">
							<i
								class="fas fa-plus-circle fa-1x"
								v-if="producto.accionTerapeutica != null && producto.accionTerapeutica.length > 40"
							></i>
						</div>
					</div> -->
					<div
						class="col-8 col-md-10 cuadriculaDetalle pl-4"
						v-if="visibleIndicacionTerapeutica"
					>{{producto.accionTerapeutica}}</div>
					<div
						@click="cambiarVistaIndicacionTerapeutica"
						class="col-2 col-md-1 color-azul justify-content-end"
						v-if="visibleIndicacionTerapeutica"
					>
						<i class="fas fa-minus-circle fa-1x"></i>
					</div>
				</div>
				<!--Mi precio >=lg-->
				<div class="col-12 pr-0">
					<div class="row mt-1 pb-2 d-none d-xl-block bgMiPrecio">
						<div class="col-12 text-left pt-1">
							<span class="cuadriculaDetalle">Mi precio:</span>
							<span class="mi-precio" v-if="producto.precioNeto > 0">
									{{producto.precioNeto | format-number('$0,0.00')}}
							</span>
							<span v-if="producto.remate || producto.ofertado || producto.buenFin">
								<span v-text="cantidadDescuento(producto)" class="ml-1 border-radius-1 font-18 px-2 bg-remate"></span>
							</span>
							<span class="background-green-1 border-radius-1 ml-2" v-show="producto.ofertado && !producto.buenFin && !producto.remate">
								<span class="font-12 ml-2">
									Oferta: 
								</span>
								<span class="font-18 mr-2 font-weight-bold" >{{producto.precioOfertado | format-number('$0,0.00')}}</span>
								<span v-if="producto.minimoPiezasOfertas > 1" class="mr-1 font-10">Compra mínima: {{producto.minimoPiezasOfertas | format-number('0,0')}} pzas.</span>
							</span>
							<span class="bg-remate border-radius-1 ml-2" v-if="producto.remate && !producto.buenFin && !producto.ofertado">
								<span class="font-12 ml-2">
									Remate: 
								</span>
								<span class="font-18 mr-2 font-weight-bold" >{{producto.precioRemate | format-number('$0,0.00')}}</span>
								<span v-if="producto.minimoPiezasRemates > 1" class="mr-1 font-10">Compra mínima: {{producto.minimoPiezasRemates | format-number('0,0')}} pzas.</span>
							</span>
							<span class="bg-buen-fin border-radius-1" v-if="(producto.buenFin) || (producto.buenFin && producto.ofertado) || (producto.buenFin && producto.remate)">
								<span class="font-12 ml-2">
									Buen Fin: 
								</span>
								<span class="font-18 font-weight-bold" >{{producto.precioBuenFin | format-number('$0,0.00')}}</span>
							</span>
						</div>
					</div>
					<!--Botones >=lg-->
					<div class="row d-none d-xl-block">
						<div
							:class="[producto.ofertado?'bg-oferta':'bgdivbotones', producto.nuevo?'bg-nuevo':'bgdivbotones', producto.remate?'bg-remate':'bgdivbotones' ]"
							class="d-none d-xl-block d-inline-block text-left"
							style="height: 76px;"
						>
							<label class="text-white fuenteCantidad d-inline-block pl-4 mt-4">Cantidad:</label>
							<input
								@focus="focus"
								class="form-control form-control-sm bg-white text-center d-inline-block tamano-caja-cantidad pl-1 mx-2"
								maxlength="4"
								ref="input"
								type="text"
								v-model="producto.cantidad"
								v-number
								v-on:blur="aceptar"
								v-on:keyup.enter="aceptar"
							/>

							<button
								:class="[producto.ofertado?'fuente-boton':'fuente-boton', producto.nuevo?'fuente-boton-nuevo':'fuente-boton', producto.remate?'fuente-boton':'fuente-boton' ]"
								@click="aceptar"
								class="link btn btn-block form-control form-control-sm tamano-boton-anadir text-white d-inline-block pl-1"
							>Añadir a pedido</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--Mi precio <lg-->
		<div class="row mt-1 mb-2 d-block d-xl-none">
			<div class="col-12 text-left">
				<span class="cuadriculaDetalle">Mi precio:</span>
				<span class="mi-precio">
					<span v-if="producto.precioNeto > 0">
						{{producto.precioNeto | format-number('$0,0.00')}}
					</span>

				</span>		
				<span v-if="producto.remate || producto.ofertado || producto.buenFin">
					<span v-text="cantidadDescuento(producto)" class="m1-1 border-radius-1 font-15 px-1 bg-remate"></span>
				</span>
			</div>
			<div class="col-12 text-left background-green-1 border-radius-1" v-show="producto.ofertado && !producto.buenFin && !producto.remate">
				<span class="mr-1 font-13">Oferta:</span>
				<span class="mr-1 font-15 font-weight-bold">{{producto.precioOfertado | format-number('$0,0.00')}}</span>
				<span v-if="producto.minimoPiezasOfertas > 1" class="mr-1 font-10">Compra mínima: {{producto.minimoPiezasOfertas | format-number('0,0')}} pzas.</span>
			</div>
			<div class="col-12 text-left bg-remate border-radius-1" v-show="producto.remate && !producto.buenFin && !producto.ofertado">
				<span class="mr-1 font-13">Remate:</span>
				<span class="mr-1 font-15 font-weight-bold">{{producto.precioRemate | format-number('$0,0.00')}}</span>
				<span v-if="producto.minimoPiezasRemates > 1" class="mr-1 font-10">Compra mínima: {{producto.minimoPiezasRemates | format-number('0,0')}} pzas.</span>
			</div>
			<div class="col-12 text-left bg-remate border-radius-1" v-show="(producto.buenFin) || (producto.buenFin && producto.ofertado) || (producto.buenFin && producto.remate)">
				<span class="mr-1 font-13">Buen Fin:</span>
				<span class="font-15 font-weight-bold">{{producto.precioBuenFin | format-number('$0,0.00')}}</span>
			</div>
		</div>
		<!--Botones <lg-->
		<div class="d-block d-xl-none">
			<div
				:class="[producto.ofertado?'bg-oferta':'bgdivbotones', producto.nuevo?'bg-nuevo':'bgdivbotones', producto.remate?'bg-remate':'bgdivbotones' ]"
				class="row"
			>
				<div class="offset-md-0 col-md-2 text-left fuenteCantidad">
					<label class="text-white mt-3">Cantidad:</label>
				</div>
				<div class="col-12 col-md-9 mt-1">
					<div class="row">
						<input
								@focus="focus"
								class="form-control form-control-sm bg-white text-right offset-md-0 col-md-5 mt-md-2 pl-md-2 mx-2"
								maxlength="4"
								ref="input1"
								type="text"
								v-model="producto.cantidad"
								v-number
								v-on:blur="aceptar"
								v-on:keyup.enter="aceptar"
							/>
						<button
							:class="[producto.ofertado?'fuente-boton':'fuente-boton', producto.nuevo?'fuente-boton-nuevo':'fuente-boton', producto.remate?'fuente-boton':'fuente-boton' ]"
							@click="aceptar"
							class="link btn btn-block form-control form-control-sm  offset-md-0 col-md-5 text-white mt-2 mb-3 pl-md-2 mx-2"
						>Añadir a pedido</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				visibleFormula: false,
				visibleIndicacionTerapeutica: false,
				cantidadBackup: 0,
				//localValue: this.value,	
			}
		},
		props: ["codArticulo", "producto", "paisOrigen"],
		mounted() {
			//console.log("producto =>", this.producto.buenFin)
			// console.log("producto =>", this.producto.precioBuenFin)
		},
		methods: {
			cortarTexto(cadena, fin) {
				if (cadena != undefined) {
					if (cadena.length > fin) {
						return cadena.substr(0, fin) + "..."
					} else {
						return cadena.substr(0, cadena.length)
					}
				}
			},
			cambiarVistaIndicacionTerapeutica() {
				this.visibleIndicacionTerapeutica = !this.visibleIndicacionTerapeutica
			},
			cambiarVistaFormula() {
				this.visibleFormula = !this.visibleFormula
			},
			// anadirPedido() {
			// 	if (this.producto.cantidad > 0){
			// 		this.aceptar()
			// 	}				
			// },
			aceptar() {
				
				if(this.cantidadBackup !== this.producto.cantidad ){
					this.$emit("cantidad", this.producto.cantidad, this.cantidadBackup)
				}
			},
			
			focus() {
				this.$refs.input.select()
				this.$refs.input1.select()
				this.cantidadBackup = this.producto.cantidad
			},		
			imagenOptima(item) {
				return item.urlImagen + this.imgExtension()
			},
			imagenDefault(item) {
				item.urlImagen = "http://www.difarmer.com/imagenes/difarmer/no_imagen"
			},
			cantidadDescuento(item){
				let precioRemateOferta = 0;
				if(item.ofertado && !item.remate && !item.buenFin)
					precioRemateOferta = item.precioOfertado
				else if((item.remate) && (!item.ofertado && !item.buenFin))
					precioRemateOferta = item.precioRemate
				else if (item.buenFin)
					precioRemateOferta = item.precioBuenFin


				let r = (((item.precioNeto - precioRemateOferta) / item.precioNeto) * 100)
				r = r < 1.00 ? r.toFixed(2) : parseInt(Math.round(r))

				return "-" + r.toString() + "% "

			}
		},
	}
</script>

<style scoped>
	.logo-buenfin{
		position: absolute;
		top: 10px;
		left: 10px;
	}

	.truncate-text {
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.plxl {
		left: -1.2rem;
	}
	.linea {
		width: 100%;
		border: 1px solid #335198;
		opacity: 1;
		border-top: 0.03rem solid var(--color-font-blue);
		margin: 0.55rem 0rem;
	}
	.color-azul {
		color: #335198;
	}
	.btn-acepto {
		background-color: #335198;
		font-size: 14px;
		font-family: "Open Sans", sans-serif;
		font-weight: normal;
		letter-spacing: 0;
		border-radius: 4px;
		color: #ffffff;
		opacity: 1;
	}
	.btn-cancelar {
		background-color: #bcc1cf;
		font-size: 14px;
		font-family: "Open Sans", sans-serif;
		font-weight: normal;
		border-radius: 4px;
		letter-spacing: 0;
		color: #ffffff;
		opacity: 1;
	}
	.fuente-importante {
		font-size: 16px;
		font-family: "Open Sans", sans-serif;
		font-weight: bold;
		letter-spacing: 0;
		color: red;
		opacity: 1;
	}
	.fuente-texto-modal {
		font-size: 14px;
		font-family: "Open Sans", sans-serif;
		font-weight: normal;
		letter-spacing: 0;
		color: #335198;
		opacity: 1;
	}
	.fuente-pregunta-modal {
		font-size: 16px;
		font-family: "Open Sans", sans-serif;
		font-weight: bold;
		letter-spacing: 0;
		color: #335198;
		opacity: 1;
	}
	.fuente-cedis-modal {
		font-size: 16px;
		font-family: "Open Sans", sans-serif;
		font-weight: normal;
		letter-spacing: 0;
		color: #335198;
		opacity: 1;
	}
	.tamano-liston {
		z-index: 1;
		position: absolute;
		width: 75px;
		height: 25px;
	}
	.tamano-icono {
		width: 49px;
		height: 50px;
	}
	.estrella {
		width: 18px;
		height: 18px;
		left: -0.5rem;
		margin-top: 0.5rem;
		position: absolute;
	}
	.div-fechacaducidad{
		border: 2px solid #4fc147;
		/* padding: 3px;  */
		border-radius: 3px;
		/* text-align: left; */
		color: #4fc147;
		font-weight: bold;
	}
	.bgdivbotones {
		background-color: #335198;
	}
	.bg-oferta {
		background-color: #4fc147;
	}
	.bg-remate {
		background-color: red;
	}
	.bg-buen-fin {
		color: #530101;
	}
	.bg-nuevo {
		background-color: #f1c240;
	}
	.bgMiPrecio {
		background-color: #ebebeb;
	}
	hr {
		border: 1px solid #335198;
		opacity: 1;
		margin-top: 0.5%;
		margin-bottom: 0.5%;
		margin-right: 1.1%;
	}

	.fuente-pais {
		text-align: left;
		font-size: 12px;
		font-family: "Open Sans", sans-serif;
		font-weight: bold;
		letter-spacing: 0;
		color: #020e2a;
		opacity: 1;
	}

	.img-bandera {
		width: 60px;
		height: 36px;
	}
	.text-white {
		color: #ffffff;
	}
	/* sm */
	.fuente-boton {
		font-family: "Open Sans", sans-serif;
		background-color: #fcba03 !important;
		border-color: #fcba03 !important;
	}
	.fuente-boton:hover {
		background-color: #fca503 !important;
		border-color: #fca503 !important;
		color: #ffffff !important;
	}

	.fuente-boton-nuevo {
		font-family: "Open Sans", sans-serif;
		background-color: #4fc147 !important;
		border-color: #4fc147 !important;
	}
	.fuente-boton-nuevo:hover {
		background-color: #239b56 !important;
		border-color: #239b56 !important;
		color: #ffffff !important;
	}

	.cantidad-existencia {
		text-align: left !important;
		font-size: 16px;
		font-family: "Open Sans", sans-serif;
		font-weight: bold;
		color: #335198;
		letter-spacing: 0;
		opacity: 1;
	}

	.mi-precio {
		text-align: left;
		font-size: 18px;
		font-family: "Open Sans", sans-serif;
		font-weight: bold;
		color: #335198;
		letter-spacing: 0;
		opacity: 1;
	}
	.cantidad-colectivo {
		text-align: left !important;
		font-size: 20px;
		font-family: "Open Sans", sans-serif;
		font-weight: bold;
		letter-spacing: 0;
		color: #335198;
		opacity: 1;
	}

	@media screen and (max-width: 767px) {
		.tamano-imagen {
			width: 318px;
			height: 317px;
		}

		.fuenteTitulo {
			text-align: left;
			font-size: 22px;
			font-family: "Open Sans", sans-serif;
			font-weight: bold;
			letter-spacing: 0;
			color: #335198;
			opacity: 1;
		}
		.fuenteGenerico {
			text-align: left;
			font-size: 14px;
			font-family: "Open Sans", sans-serif;
			font-weight: bold;
			letter-spacing: 0;
			color: #335198;
			opacity: 1;
		}
		.fuenteFormula {
			text-align: left;
			font-size: 14px;
			font-family: "Open Sans", sans-serif;
			letter-spacing: 0;
			color: #335198;
			opacity: 1;
		}

		.cuadriculaTitulo {
			text-align: left;
			font-size: 12px;
			font-family: "Open Sans", sans-serif;
			font-weight: bold;
			letter-spacing: 0;
			color: #335198;
			opacity: 1;
		}

		.cuadriculaDetalle {
			text-align: left;
			font-size: 12px;
			font-family: "Open Sans", sans-serif;
			letter-spacing: 0;
			color: #335198;
			opacity: 1;
		}
		.fuenteCantidad {
			text-align: left !important;
			font-size: 18px;
			font-family: "Open Sans", sans-serif;
			letter-spacing: 0;
			opacity: 1;
		}
		.fuente-caja-cantidad {
			border-radius: 6px;
			width: 260px;
			text-align: left;
			font-size: 18px;
			font-family: "Open Sans", sans-serif;
			letter-spacing: 0;
			opacity: 1;
		}
	}

	/* md */
	@media screen and (min-width: 768px) and (max-width: 1199px) {
		.tamano-modal {
			max-width: 617px !important;
			max-height: 366px !important;
			background-color: #ebebeb;
		}

		.tamano-imagen {
			width: 318px;
			height: 317px;
		}

		.fuenteTitulo {
			text-align: left;
			font-size: 22px;
			font-family: "Open Sans", sans-serif;
			font-weight: bold;
			letter-spacing: 0;
			color: #335198;
			opacity: 1;
		}
		.fuenteGenerico {
			text-align: left;
			font-size: 14px;
			font-family: "Open Sans", sans-serif;
			font-weight: bold;
			letter-spacing: 0;
			color: #335198;
			opacity: 1;
		}
		.fuenteFormula {
			text-align: left;
			font-size: 14px;
			font-family: "Open Sans", sans-serif;
			letter-spacing: 0;
			color: #335198;
			opacity: 1;
		}

		.cuadriculaTitulo {
			text-align: left;
			font-size: 12px;
			font-family: "Open Sans", sans-serif;
			font-weight: bold;
			letter-spacing: 0;
			color: #335198;
			opacity: 1;
		}

		.cuadriculaDetalle {
			text-align: left;
			font-size: 12px;
			font-family: "Open Sans", sans-serif;
			letter-spacing: 0;
			color: #335198;
			opacity: 1;
		}
		.fuenteCantidad {
			font-size: 18px;
			font-family: "Open Sans", sans-serif;
			letter-spacing: 0;
			opacity: 1;
		}
		.fuente-caja-cantidad {
			border-radius: 6px;
			width: 260px;
			text-align: left;
			font-size: 18px;
			font-family: "Open Sans", sans-serif;
			letter-spacing: 0;
			opacity: 1;
		}

		.fuente-caja-cantidad {
			border-radius: 6px;
			width: 260px;
			text-align: left;
			font-size: 18px;
			font-family: "Open Sans", sans-serif;
			letter-spacing: 0;
			opacity: 1;
		}
	}

	/* xl */
	@media screen and (min-width: 1200px) {
		.tamano-modal {
			width: 20% !important;
			max-height: 366px !important;
			background-color: #ebebeb;
		}
		.alineat-abajo {
			position: absolute;
			bottom: 5px;
		}
		.tamano-caja-cantidad {
			width: 100px;
			height: 37px;
		}
		.tamano-boton-anadir {
			width: 180px;
		}
		.tamano-icono {
			width: 50px;
			height: 51px;
		}
		.tamano-imagen {
			width: 289px;
			height: 289px;
			margin-top: 35%;
		}

		.fuenteTitulo {
			text-align: left;
			font-size: 22px;
			font-family: "Open Sans", sans-serif;
			font-weight: bold;
			letter-spacing: 0;
			color: #335198;
			opacity: 1;
		}
		.fuenteGenerico {
			text-align: left;
			font-size: 14px;
			font-family: "Open Sans", sans-serif;
			font-weight: bold;
			letter-spacing: 0;
			color: #335198;
			opacity: 1;
		}
		.fuenteFormula {
			text-align: left;
			font-size: 14px;
			font-family: "Open Sans", sans-serif;
			letter-spacing: 0;
			color: #335198;
			opacity: 1;
		}

		.cuadriculaTitulo {
			text-align: left;
			font-size: 12px;
			font-family: "Open Sans", sans-serif;
			font-weight: bold;
			letter-spacing: 0;
			color: #335198;
			opacity: 1;
		}

		.cuadriculaDetalle {
			text-align: left;
			font-size: 12px;
			font-family: "Open Sans", sans-serif;
			letter-spacing: 0;
			color: #335198;
			opacity: 1;
		}
		.fuenteCantidad {
			text-align: left !important;
			font-size: 18px;
			font-family: "Open Sans", sans-serif;
			letter-spacing: 0;
			opacity: 1;
		}
		.fuente-caja-cantidad {
			border-radius: 6px;
			width: 260px;
			text-align: left;
			font-size: 18px;
			font-family: "Open Sans", sans-serif;
			color: #335198;
			letter-spacing: 0;
			opacity: 1;
		}

		.fuente-caja-cantidad {
			border-radius: 6px;
			width: 260px;
			text-align: left;
			font-size: 18px;
			font-family: "Open Sans", sans-serif;
			letter-spacing: 0;
			opacity: 1;
		}

	}

	.texto-producto-sin-devolucion {
		font-size: 12px;
		margin-left: 15px;
		font-family: "Open Sans";
		color: #ff0000;
		font-weight: bold;
	}
</style>
